import { useEffect, useRef } from 'react';

interface Props {
  iframeSrc: string;
}

export function useHistorySnapshot({ iframeSrc }: Props) {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  useEffect(() => {
    iframeRef.current?.contentWindow?.location.replace(iframeSrc);
  }, [iframeSrc]);
  return {
    iframeRef,
  };
}
